import { render, staticRenderFns } from "./SmFreeFormatNotificationElement.vue?vue&type=template&id=b3e4536a&scoped=true&"
import script from "./SmFreeFormatNotificationElement.vue?vue&type=script&lang=ts&"
export * from "./SmFreeFormatNotificationElement.vue?vue&type=script&lang=ts&"
import style0 from "./SmFreeFormatNotificationElement.vue?vue&type=style&index=0&id=b3e4536a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e4536a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
